<template>
  <resource-box name="回收体系">
    <div class="overview" slot="content">
      <div
        v-for="(item, index) in overviewData"
        :key="index"
        @click="typeBtn(item)"
      >
        <div class="overview_imgs">
          <img class="overview_imgs_icon" :src="item.FrameTop" alt="" />
          <img :src="item.FrameBtn" alt="" />
        </div>
        <div class="overview_content">
          <div class="overview_content_name">{{ item.typeName }}</div>
          <div class="overview_content_nums">
            {{ item.nums ? item.nums : 0 }}<span>个</span>
          </div>
        </div>
      </div>
    </div>
  </resource-box>
</template>

<script>
import resourceBox from '@/views/IndustryMap/components/resourceBox.vue';
import { getOverViewName } from '@/API/echarts/echarts'
export default {
  name: 'dataOverview',
  components: {
    resourceBox,
  },
  data() {
    return {
      overviewData: [
        {
          FrameBtn: require('@/assets/recycling/echartsMap/Frame.svg'),
          FrameTop: require('@/assets/recycling/echartsMap/Frame_01.svg'),
          typeName: '',
          key: 'recycleStation',
          typeValue: 1010,
          id: '',
          nums: '',
          typeCode: 1,
        },
        {
          FrameBtn: require('@/assets/recycling/echartsMap/Frame.svg'),
          FrameTop: require('@/assets/recycling/echartsMap/Frame_02.svg'),
          typeName: '',
          key: 'transferStation',
          typeValue: 1011,
          id: '',
          nums: '',
          typeCode: 2,
        },
        {
          FrameBtn: require('@/assets/recycling/echartsMap/Frame.svg'),
          FrameTop: require('@/assets/recycling/echartsMap/Frame_03.svg'),
          typeName: '',
          key: 'sortingCenter',
          typeValue: 1012,
          id: '',
          nums: '',
          typeCode: 3,
        },
        {
          FrameBtn: require('@/assets/recycling/echartsMap/Frame.svg'),
          FrameTop: require('@/assets/recycling/echartsMap/Frame_04.svg'),
          typeName: '',
          key: 'wasteEnterprise',
          typeValue: 1013,
          id: '',
          nums: '',
          typeCode: 4,
        },
        {
          FrameBtn: require('@/assets/recycling/echartsMap/Frame.svg'),
          FrameTop: require('@/assets/recycling/echartsMap/Frame_06.svg'),
          typeName: '',
          key: 'industrialPark',
          typeValue: 1015,
          id: '',
          nums: '',
          typeCode: 6,
        },
        {
          FrameBtn: require('@/assets/recycling/echartsMap/Frame.svg'),
          FrameTop: require('@/assets/recycling/echartsMap/Frame_05.svg'),
          typeName: '',
          key: 'dismantlingCenter',
          typeValue: 1014,
          id: '',
          nums: '',
          typeCode: 5,
        },
      ],
      keys: [
        /*回收网点*/
        'recycleStation',
        /*中转站*/
        'transferStation',
        /*分拣中心*/
        'sortingCenter',
        /*利废企业*/
        'wasteEnterprise',
        /*产业园区*/
        'industrialPark',
        /*二手交易市场*/
        'dismantlingCenter',
      ],
    };
  },
  props: {
    mapData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    mapData: {
      handler: function (val) {
        if (val) {
          let type = this.$store.state.echartsMap.dataType == 1 ? 1031 : 1030; //1030省社,1031全省
          getOverViewName(type).then((res) => {
            if (res.code === 200) {
              let nameObj = {}
              if(res.data && res.data.length) {
                res.data.forEach(item=>{
                  nameObj[item.keyName] = item.name;
                })
                this.overviewData.forEach((temp,index)=>{
                  temp.typeName = nameObj[temp.key]
                  temp.nums = val[this.keys[index]];
                  temp.id = val.id;
                })
              }
            }
          });
        }
      },
    },
  },
  methods: {
    typeBtn(item) {
      if (this.$store.state.echartsMap.Maplevel > 1) return;
      this.$store.commit('echartsMap/changeIsLower', item);
      this.$store.commit('echartsMap/changeLowerLevelData', item);
      this.$store.commit('echartsMap/changeGlanceType', item);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.overview {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  align-content: space-around;
  height: 100%;
  div {
    flex: 0 0 calc(33.3%); /* 每行3个 */
    box-sizing: border-box;
  }
}
.overview_imgs {
  display: flex;
  justify-content: center;
}
.overview_content {
  text-align: center;
  div {
    display: inline-block;
  }
}
.overview_imgs {
  position: relative;
  padding-top: 20px;
  cursor: pointer;
  .overview_imgs_icon {
    position: absolute;
    left: 40%;
    bottom: 39%;
    animation: bounce 2s infinite;
  }
  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }
}
.overview_content {
  .overview_content_nums {
    margin-left: 5px;
    font-size: 16px;
    color: rgba(47, 241, 255, 1);
    font-weight: 500;
    max-width: 80px;
    span {
      font-size: 12px;
      margin-left: 5px;
    }
  }
  .overview_content_name {
    font-size: 13px;
    color: #ffffff;
  }
}
</style>
